import { render, staticRenderFns } from "./singleItem.vue?vue&type=template&id=374a7270&scoped=true"
import script from "./singleItem.vue?vue&type=script&lang=js"
export * from "./singleItem.vue?vue&type=script&lang=js"
import style0 from "./singleItem.vue?vue&type=style&index=0&id=374a7270&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374a7270",
  null
  
)

export default component.exports